import api from './api.service';
import { tokenService } from './token.service';

export interface PaymentIntentResponse {
    clientSecret: string;
    id: string;
}

export interface GetPaymentsData {
    id: number;
    amount: number;
    currency: string;
    createdDate: Date;
    tracking: string;
    idOrder: number;
    isPaid?: boolean;
    isVoided?: boolean;
    isRefunded?: boolean;
}

export interface GetPaymentsResponse {
    statusCode: number;
    message: string;
    data: GetPaymentsData[];
    pagination: {
        page: number;
        pageSize: number;
        totalPages: number;
    };
}

class PaymentService {
    async createPaymentIntent(amount: number, currency: string, description: string, customerEmail: string): Promise<PaymentIntentResponse> {
        const token = tokenService.getToken();
        try {
            const response = await api.post<PaymentIntentResponse>('/create-payment-intent', {
                amount,
                currency,
                description,
                customerEmail
            }, {
                headers: {
                    Authorization: `${token}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error creating payment intent:', error);
            throw error;
        }
    }

    async getPayments(params: {
        page?: number;
        pageSize?: number;
        startDate?: string;
        endDate?: string;
        SearchString?: string;
    }): Promise<GetPaymentsResponse> {
        const token = tokenService.getToken();
        try {
            const response = await api.get<GetPaymentsResponse>(`/get-payments`, {
                params,
                headers: {
                    Authorization: `${token}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching payments:", error);
            throw error;
        }
    }
}

export const paymentService = new PaymentService();
